import { render, staticRenderFns } from "./ControlAccesosPersona.vue?vue&type=template&id=7e5b464e&scoped=true"
import script from "./ControlAccesosPersona.vue?vue&type=script&lang=js"
export * from "./ControlAccesosPersona.vue?vue&type=script&lang=js"
import style0 from "./ControlAccesosPersona.vue?vue&type=style&index=0&id=7e5b464e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5b464e",
  null
  
)

export default component.exports